export const SET_SC_HOME_PAGE_RESPONSE = "SET_SC_HOME_PAGE_RESPONSE";
export const SET_SC_HOME_PAGE_DETAILS = "SET_SC_HOME_PAGE_DETAILS";
export const SET_SC_HOME_PAGE_CDN_URL = "SET_SC_HOME_PAGE_CDN_URL";